import { BLOCK_TYPES, renderSettingsShortnLong } from "../../common";

const { SHORT_ANSWER_BLOCK } = BLOCK_TYPES;

const renderSettingsLongAnswer = (block: any) =>
    renderSettingsShortnLong(block, SHORT_ANSWER_BLOCK);

export default renderSettingsLongAnswer;
